module.exports = __webpack_public_path__ + "static/online-shop-logo-1a04789c67acc3b69805359815f8c5f5.png";